const state = () => ({
  checked: false,
});

const mutations = {
  setChecked(state, flag) {
    state.checked = flag;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
